import { Navigate, type RouteObject } from 'react-router-dom';
import App from '@components/app';
import Earn from '@pages/earn';
import { type FC } from 'react';

const subRoutes: RouteObject[] = [
  {
    path: '/',
    element: <Navigate to="/earn" />,
  },
  {
    path: '/about',
    lazy: () => lazyLoad(import('@pages/about')),
  },
  {
    path: '/earn',
    element: <Earn />,
  },
  {
    path: '/leaderboard',
    lazy: () => lazyLoad(import('@pages/leaderboard')),
  },
  {
    path: '/swap',
    lazy: () => lazyLoad(import('@pages/cetus-swap')),
  },
  {
    path: '/pools',
    lazy: () => lazyLoad(import('@pages/pools')),
  },
  // {
  //   path: '/portfolio',
  //   lazy: () => lazyLoad(import('@pages/portfolio')),
  // },
  // {
  //   path: '/pools',
  //   lazy: () => lazyLoad(import('@pages/pool')),
  // },
  // {
  //   path: '/pools/create',
  //   lazy: () => lazyLoad(import('@pages/create-pool')),
  // },
  // {
  //   path: '/pools/:poolId/add-liquidity',
  //   lazy: () => lazyLoad(import('@pages/pool-add-liquidity')),
  // },
  // {
  //   path: '/portfolio/:positionId/position',
  //   lazy: () => lazyLoad(import('@pages/position')),
  // },
  // {
  //   path: '/account/transaction',
  //   lazy: async () => lazyLoad(import('@pages/account-transaction')),
  // },
  // {
  //   path: '/fun',
  //   lazy: () => lazyLoad(import('@pages/fun')),
  // },
  // {
  //   path: '/fun/create',
  //   lazy: () => lazyLoad(import('@pages/fun-create')),
  // },

  // {
  //   path: '/fun/:id',
  //   lazy: () => lazyLoad(import('@pages/fun-detail')),
  // },
  // {
  //   path: '/fun/leaderboard',
  //   lazy: () => lazyLoad(import('@pages/fun-leaderboard')),
  // },
  // {
  //   path: '/fun/advanced',
  //   lazy: () => lazyLoad(import('@pages/fun-advanced')),
  // },

  // {
  //   path: '/bridge',
  //   lazy: async () => lazyLoad(import('@pages/bridge')),
  // },
  // {
  //   path: '/stats',
  //   lazy: async () => lazyLoad(import('@pages/info')),
  // },
  // {
  //   path: '/lp-lock',
  //   lazy: async () => lazyLoad(import('@pages/lp-burn')),
  // },
  // {
];

export const routerObjects: RouteObject[] = [
  {
    element: <App />,
    children: subRoutes,
  },
];

const lazyLoad = async (dynamicImport: Promise<{ default: FC }>) => {
  const obj = await dynamicImport;
  return {
    Component: obj.default,
  };
};
